<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>Son Kullanıcı Yönetimi</h4>
      <v-row style="margin-top: 100px;">
        <v-col cols="12" md="4">
          <h4>Ad</h4>
          <v-text-field
            v-model="userData.firstName"
            disabled
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Soyad</h4>
          <v-text-field
            v-model="userData.lastName"
            disabled
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Mail Adresi</h4>
          <v-text-field
            v-model="userData.email"
            disabled
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Telefon Numarası</h4>
          <v-text-field
            v-model="userData.phoneNumber"
            v-mask="'+90##########'"
            disabled
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Fotoğraf</h4>
          <img v-bind:src="userData.img" width="350px" height="350px" />
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Fotoğraf Değiştirme Sayısı</h4>
          <v-text-field
            v-model="userData.imgUpdateCount"
            disabled
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <v-btn
            depressed
            color="#4d48f9"
            style="color: white;"
            @click="resetImgUpdateCount()"
          >
            Fotoğraf Değiştirme Hakkı Sıfırla
          </v-btn>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4" v-if="userData.hasSubscriptionPlan === true">
          <h4>Üyelik Paketi</h4>
          <v-text-field
            v-model="userData.subscription"
            disabled
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4" v-if="userData.hasMembership === true">
          <h4>Üyelik Durumu</h4>
          <v-text-field
            v-model="userData.membershipStatus"
            disabled
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4" v-if="userData.hasMembership === true">
          <h4>Üyelik Başlangıç Tarihi</h4>
          <v-text-field
            v-model="userData.membershipStartDate"
            disabled
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4" v-if="userData.hasMembership === true">
          <h4>Üyelik Bitiş Tarihi</h4>
          <v-text-field
            v-model="userData.membershipEndDate"
            disabled
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4" v-if="userData.canUserRemovable === true">
          <v-btn
            depressed
            color="#4d48f9"
            style="color: white;"
            @click.stop="dialogDelete = true"
          >
            Üyeliği İptal Et
          </v-btn>
        </v-col>
        <v-col cols="12" md="8"></v-col>
      </v-row>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="fruit in this.errorList" :key="fruit">{{ fruit }}</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDelete" max-width="390">
        <v-card>
          <v-card-title class="headline">Uyarı</v-card-title>

          <v-card-text>{{ userData.userRemovableStatusMessage }}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              style="color: #1565c0 !important;"
              text
              @click="dialogDelete = false"
            >
              Vazgeç
            </v-btn>

            <v-btn
              color="red"
              style="color: #d9534f !important;"
              text
              @click="removeSubscription()"
            >
              Onayla
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- <v-row>

      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'EndUserManagementDetail',
  data: () => ({
    valid: true,
    errorList: [],
    dialog: false,
    dialogDelete: false,
  }),
  computed: mapGetters(['userData']),
  created() {
    let userId = this.$route.params.id
    this.getUser(userId)
  },
  methods: {
    ...mapActions([
      'getUser',
      'resetUserImgUpdateCount',
      'removeUserSubscription',
    ]),
    resetImgUpdateCount() {
      this.resetUserImgUpdateCount(this.$route.params.id).then((response) => {
        if (response.processStatus == 'Success') {
          this.$router.go(this.$router.currentRoute)
        } else {
          console.log(response.propcessStatus)
          alert('Güncelleme işlemi gerçekleştirilemedi')
        }
      })
    },
    removeSubscription() {
      this.removeUserSubscription(this.$route.params.id).then((response) => {
        if (response.processStatus == 'Success') {
          this.$router.go(this.$router.currentRoute)
          this.dialogDelete = false
        } else {
          console.log(response.propcessStatus)
          alert('Üyelik iptal işlemi gerçekleştirilemedi')
        }
      })
    },
  },
}
</script>
